import { IViewDetail } from '../../global';
import { IGalleryData, IGalleryList } from './GalleryType';
import { IComponentLink } from '../../component';

export default function(link: IComponentLink, gallerys: IGalleryList) {
  let view_detail = {
    view: 0,
    uv: 0
  } as IViewDetail;
  let { type, value, link_id } = link;
  let gallery = (gallerys[value + ''] || {}) as IGalleryData;
  let image_total = 0;
  if ((type == 'gallery' || type == 'subgallery') && !!gallery) {
    image_total = gallery.image_total || 0;
    if (gallery.view_detail != null) {
      view_detail = gallery.view_detail as IViewDetail;
    }
  }
  return {
    image_total,
    view_detail,
    gallery
  };
}
